export const typeOfStructureDialog = 'typeOfStructureDialog';
export const structureDialogId = 'structureDialog';
